export default "__VITE_ASSET__b8d024d5__"